
















import Vue from 'vue'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import ImageUpload from '@/components/products/framepuzzle/FramePuzzleImageUpload.vue'
import FramePuzzleCloseButton from '@/components/products/framepuzzle/FramePuzzleCloseButton.vue'
import FramePuzzleSingleAssetUpload from '@/components/products/framepuzzle/util/FramePuzzleSingleAssetUpload'
import { FramePuzzleAssetUsage } from '@/components/products/framepuzzle/util/FramePuzzleAssetUsage'
import { FrameClipper } from '@/components/products/framepuzzle/util/frameClipper'
import { AssetsModule } from '@/store/modules/asset'
import { FramePuzzleModule, CollageInfo, PuzzleBoxUpdateState } from '@/store/modules/framePuzzle'
import { AssetFile, SingleAssetUsage, BoundingBox, Point } from '@/store/modules/asset'
import { ToolbarModule } from '@/store/modules/toolbar'
import updateAssetAttributes from '@/components/products/framepuzzle/util/assetAttributesUpdateUtil'

@Component({
    name: 'puzzle-overlay-upload',
    components: { FramePuzzleCloseButton, ImageUpload }
})
export default class PuzzleOverlayUpload extends Mixins(FramePuzzleSingleAssetUpload) {

    get confirmed() {
        return ToolbarModule.confirmed
    }

    @Watch('confirmed')
    confirmedChanged() {
        this.confirm()
    }

    doConfirm(asset?: AssetFile, imageClipper?: FrameClipper, usage?: SingleAssetUsage): boolean {
        if (asset && asset.assetId && usage && imageClipper) {
            let info: CollageInfo = new CollageInfo(asset.assetId as number, imageClipper.boundingBox as BoundingBox, usage.rotation as number, false)
            if (FramePuzzleModule.allCollages['frameimage'] == undefined || info.attributesChanged(FramePuzzleModule.allCollages['frameimage'])) {
                info.attributesNeedUpdate = true
            }
            FramePuzzleModule.SetCollageInfo(info)
            if (info.attributesNeedUpdate == true) {
                FramePuzzleModule.SetPuzzleBoxUpdateState(PuzzleBoxUpdateState.UPDATING_ASSET_ATTRIBUTES)
            }
            this.$nextTick(() => {
                if (ToolbarModule.deactivated === 0) {
                    updateAssetAttributes().then(
                        (value) => {
                            //nothing
                        },
                        (reason) => {
                            window.console.log(reason)
                        });
                }
            })
            return true
        } else {
            return false
        }
    }

    onClose() {
        this.$emit('close')
    }

    onCancel() {
        this.cancel()
    }

    mounted() {
        this.$nextTick(() => {
            this.initSingleImage()
        })
    }

    initSingleImage() {
        this.$nextTick(() => {
            let usagename = "frameimage"
            let asset = FramePuzzleModule.activeAssets[usagename]
            if (asset) {
                FramePuzzleAssetUsage.prepareCollageUsage(asset, usagename)
                AssetsModule.Select(asset)
                this.asset = asset
            }
        })
    }
}
